var map = {
	"./audio.png": 7493,
	"./cetemin-logo.png": 1557,
	"./colaborador.png": 1772,
	"./doc.png": 9171,
	"./estudiante.png": 3856,
	"./excel.png": 5584,
	"./file.png": 3641,
	"./grafico-de-barras.png": 2911,
	"./header-solicitud.png": 6008,
	"./icons/192.png": 3938,
	"./icons/32.png": 4339,
	"./icons/512.png": 299,
	"./imagen.png": 548,
	"./logo.png": 6949,
	"./microsoft-logo.png": 6706,
	"./pdf.png": 475,
	"./powerpoint.png": 9939,
	"./rocket.png": 8804,
	"./support.png": 6145,
	"./ticket.png": 6093,
	"./txt.png": 5516,
	"./video.png": 9235,
	"./zip.png": 2635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;